<template>
  <header>
    <nav class="navbar is-dark" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <div class="navbar-item">&lt;clublink/&gt;</div>
        <a role="button" class="navbar-burger" :class="classIsActive" aria-label="menu" aria-expanded="false" @click="toggleMenu">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div class="navbar-menu is-dark" :class="classIsActive">
        <div class="navbar-end">
          <div v-if="user" class="navbar-item">
            Signed in as {{user.displayName}}
          </div>
          <div class="navbar-item">
            <sign-button />
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import SignButton from '@/components/SignButton.vue'

export default {
  name: 'clublink-header',
  components: {
    SignButton
  },
  data () {
    return {
      user: null,
      menuIsActive: false
    }
  },
  computed: {
    classIsActive () {
      return {
        'is-active': this.menuIsActive
      }
    }
  },
  methods: {
    toggleMenu () {
      this.menuIsActive = !this.menuIsActive
    }
  }
}
</script>
